export const WHEELS_SEO = {
  title: "Spin the Wheel – Free Random Name & Decision Wheel Picker | DITHER",
  description: "Make your own spin-the-wheel in seconds: add names or options, give some extra chances, save it and spin anytime. Free, no sign-up.",
  keywords: "spin the wheel, random wheel, wheel of names, decision wheel, random name picker, wheel spinner, prize wheel, custom wheel",
  h1: "Spin the wheel",
  intro: "DITHER's free spin-the-wheel lets you build your own random wheel of names or options, save it, and spin it whenever you need a fair, fun decision.",
  steps: [
    { title: "Make a wheel", text: "Tap New wheel or start from a template, then give it a name like \"Takeaway spots\" or \"Class 4B\"." },
    { title: "Add options & weights", text: "Add 2 to 20 names or options. Tap 1× to make a favourite 2× or 3× more likely to win." },
    { title: "Spin & share", text: "Hit Spin, watch the wheel slow down and land, then save or share the result. Spin again anytime." },
  ],
  uses: [
    { title: "Classroom name picker", text: "Pick who answers next without anyone crying favouritism." },
    { title: "Who goes first", text: "Settle board games, karaoke order or who drives tonight." },
    { title: "Prize wheels", text: "Run a giveaway or office prize spin with weighted prizes." },
    { title: "Dinner choices", text: "Save your go-to takeaways and let the wheel choose." },
    { title: "Team picks", text: "Pick captains or split people into sides." },
    { title: "Chores", text: "Spin to see who takes the bins out this week." },
  ],
  why: [
    "Weighted options: give an option 2× or 3× the chance",
    "Saved wheels you can reuse and edit anytime",
    "Fun sound effects and a proper spinning reveal",
    "Works on any phone, tablet or computer",
    "Free, with no sign-up needed",
  ],
  faqs: [
    { q: "Is the wheel really random?", a: "Yes. Every spin uses your browser's secure random number generator, so each option has exactly its fair chance — nothing is fixed." },
    { q: "What does the weight (1×, 2×, 3×) do?", a: "Weight changes the chance. An option set to 2× is twice as likely to win as a 1× option, and 3× is three times as likely. The editor shows each option's percentage chance." },
    { q: "Can I save my wheel?", a: "Yes. Wheels are saved on your device automatically. Create a free account to keep them across all your devices." },
    { q: "How many options can I add?", a: "Each wheel can have between 2 and 20 options, and you can make as many wheels as you like." },
    { q: "Can I use it for a classroom or a giveaway?", a: "Absolutely — it works great as a random name picker for classes, or as a prize wheel for giveaways and raffles." },
    { q: "Do I need an account?", a: "No. You can make, save and spin wheels as a guest. An account is optional and just syncs your wheels and history." },
  ],
};
